module.exports = "<main>\n    <router-outlet></router-outlet>\n</main>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/services-main/services-main.html
// module id = LvUC
// module chunks = 0